import React from 'react';

const Decor2: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-2 prefix__map-decor"
      transform="translate(85 140)"
    >
      <defs>
        <linearGradient
          id="e09de957-5abe-4ef1-ab62-470819d338d5"
          data-name="grad-109"
          x1="1255.9"
          y1="67.19"
          x2="1339.74"
          y2="67.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#005990" />
          <stop offset="0" stopColor="#00598f" />
          <stop offset="0.07" stopColor="#0c4e71" />
          <stop offset="0.14" stopColor="#13475f" />
          <stop offset="0.18" stopColor="#154558" />
          <stop offset="0.4" stopColor="#114151" />
          <stop offset="0.86" stopColor="#0f3f4f" />
        </linearGradient>
        <linearGradient
          id="efde8c08-3745-4f18-bed5-0c8104d3500e"
          x1="373.57"
          y1="154.56"
          x2="457.42"
          y2="154.56"
          xlinkHref="#e09de957-5abe-4ef1-ab62-470819d338d5"
        />
        <linearGradient
          id="f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
          data-name="grad-28"
          x1="393.46"
          y1="143.71"
          x2="393.98"
          y2="208.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f4cb76" />
          <stop offset="1" stopColor="#bf534f" />
        </linearGradient>
        <linearGradient
          id="ba81f6ac-8d0a-47b0-8736-b31a68dd94ce"
          x1="389.27"
          y1="164.94"
          x2="389.56"
          y2="200.92"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b28aef1c-1307-436a-b58e-fabcd6ac6ba0"
          x1="393.63"
          y1="173.65"
          x2="392.37"
          y2="220.93"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a401e909-d6ab-4ad8-9b0c-79703ec15590"
          data-name="grad-126"
          x1="1220.5"
          y1="385.58"
          x2="1221.1"
          y2="459.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00ac90" />
          <stop offset="0.09" stopColor="#009e87" />
          <stop offset="0.37" stopColor="#00746c" />
          <stop offset="0.63" stopColor="#005658" />
          <stop offset="0.84" stopColor="#00444c" />
          <stop offset="1" stopColor="#003d48" />
        </linearGradient>
        <linearGradient
          id="b93956a2-ff8d-422b-8d5d-24d9f810271d"
          x1="1215.74"
          y1="409.75"
          x2="1216.07"
          y2="450.72"
          xlinkHref="#a401e909-d6ab-4ad8-9b0c-79703ec15590"
        />
        <linearGradient
          id="aa4f1180-7024-41ac-bccb-be5a22615aa9"
          x1="1220.69"
          y1="419.67"
          x2="1219.25"
          y2="473.5"
          xlinkHref="#a401e909-d6ab-4ad8-9b0c-79703ec15590"
        />
        <linearGradient
          id="b5ec5bc8-f633-4332-9fc6-809c1550697a"
          x1="1364.69"
          y1="455.14"
          x2="1365.13"
          y2="510.28"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="e10e8b1e-a539-4c3f-8895-3dc0fa10d053"
          x1="1361.14"
          y1="473.11"
          x2="1361.39"
          y2="503.58"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a23f39ca-9c99-4190-a50f-b5a908c0d082"
          x1="1364.83"
          y1="480.49"
          x2="1363.76"
          y2="520.53"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b1b4dd55-b30f-4e97-a430-6436ebecae6b"
          data-name="grad-58"
          x1="1092.3"
          y1="501.2"
          x2="1092.74"
          y2="556.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#dd15ff" />
          <stop offset="1" stopColor="#5f3e56" />
        </linearGradient>
        <linearGradient
          id="f05a2ccf-d568-4995-8f4c-8af8be162f85"
          x1="1088.75"
          y1="519.18"
          x2="1089"
          y2="549.65"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="ece085cd-cf6c-4418-8d58-1e4519b3756c"
          x1="1092.44"
          y1="526.56"
          x2="1091.37"
          y2="566.59"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="b5e980cd-e6c1-49b0-bdd2-e27f875a7a92"
          x1="1004.16"
          y1="202.83"
          x2="1004.74"
          y2="274.64"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="ef62b08f-aa25-4986-b685-621f0f549d94"
          x1="999.54"
          y1="226.24"
          x2="999.86"
          y2="265.91"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="a77f6d32-80fb-43a7-a662-2b4c6b0bd7da"
          x1="1004.34"
          y1="235.85"
          x2="1002.95"
          y2="287.97"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="a24e3659-b00d-428a-8602-3adf6e023498"
          x1="432.28"
          y1="363.81"
          x2="485.6"
          y2="363.81"
          xlinkHref="#a401e909-d6ab-4ad8-9b0c-79703ec15590"
        />
        <linearGradient
          id="b76627b6-8419-4cbd-93f5-3b869b92ffaa"
          x1="457.43"
          y1="305.76"
          x2="457.92"
          y2="365.74"
          xlinkHref="#a401e909-d6ab-4ad8-9b0c-79703ec15590"
        />
        <linearGradient
          id="baa786aa-35ab-4c7d-a7c2-9247da50aaca"
          x1="453.58"
          y1="325.31"
          x2="453.85"
          y2="358.45"
          xlinkHref="#a401e909-d6ab-4ad8-9b0c-79703ec15590"
        />
        <linearGradient
          id="ab13e1a4-f422-44b2-ac17-6b5c8618b015"
          x1="457.59"
          y1="333.34"
          x2="456.43"
          y2="376.87"
          xlinkHref="#a401e909-d6ab-4ad8-9b0c-79703ec15590"
        />
        <linearGradient
          id="afadb3f4-1ddd-4bec-9b0d-ba841e6f5aed"
          x1="483.63"
          y1="378.33"
          x2="520.41"
          y2="378.33"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a5c683ed-fcd6-42ab-8de9-db790a9a652b"
          x1="500.98"
          y1="338.29"
          x2="501.31"
          y2="379.66"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a1f869f9-f354-4434-a31a-5492ac5aa141"
          x1="498.32"
          y1="351.78"
          x2="498.51"
          y2="374.63"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="fe1a40bb-17a2-409c-b597-09bba327db3b"
          x1="501.09"
          y1="357.31"
          x2="500.29"
          y2="387.34"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b153d63d-3a36-4126-92bc-70472286eb25"
          x1="404.14"
          y1="388.52"
          x2="440.91"
          y2="388.52"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="a1e77f8e-89c2-41ca-9196-8f78fd343bc5"
          x1="421.49"
          y1="348.49"
          x2="421.82"
          y2="389.85"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="b1387e3a-3a6e-49cb-afa6-6b665b6b6ef5"
          x1="418.83"
          y1="361.98"
          x2="419.01"
          y2="384.83"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="a863ecb7-fc97-4fff-9a65-e6e72d371a32"
          x1="421.59"
          y1="367.51"
          x2="420.79"
          y2="397.53"
          xlinkHref="#b1b4dd55-b30f-4e97-a430-6436ebecae6b"
        />
        <linearGradient
          id="a2ba31e7-73c4-46b4-b28c-bb73833c81a2"
          x1="1382.29"
          y1="495.44"
          x2="1383.41"
          y2="636.81"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="aca654cc-46a3-4f32-8ae6-ed59aca9a11e"
          x1="1370.98"
          y1="481.3"
          x2="1372.21"
          y2="636.7"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a9114228-b6bd-4e8d-a812-07d75b509091"
          x1="1393.59"
          y1="472.11"
          x2="1394.9"
          y2="636.8"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b5123c89-b04f-42f0-adc7-8888705e3d12"
          x1="1359.67"
          y1="464.34"
          x2="1361.04"
          y2="636.47"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a922b89b-50a9-4047-ae2b-eff3eaa1d93d"
          x1="1348.36"
          y1="489.08"
          x2="1349.53"
          y2="636.17"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a52f9987-95e7-47af-9f92-b2a69f1eae39"
          x1="1325.75"
          y1="489.08"
          x2="1326.91"
          y2="634.95"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b6ea1e3e-c4b9-4ff0-8153-ea46502058be"
          x1="1337.06"
          y1="472.11"
          x2="1338.35"
          y2="635.6"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="f060c945-90d2-41fb-a084-d4b1c1eb83b2"
          x1="1416.21"
          y1="448.79"
          x2="1417.7"
          y2="636.68"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="f4b5992e-b37c-4771-8603-e6aeddbb507c"
          x1="1393.59"
          y1="438.9"
          x2="1395.15"
          y2="635.35"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="ec06554a-4ede-4b7f-a874-90404325f9d4"
          x1="1359.67"
          y1="438.9"
          x2="1361.23"
          y2="635.35"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b23271fa-d184-4c01-8daa-d4be272b216e"
          x1="1314.44"
          y1="502.5"
          x2="1315.49"
          y2="634.12"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="bf49c937-a0da-4684-9b9b-32be3e28edfe"
          x1="1404.9"
          y1="495.44"
          x2="1406.02"
          y2="636.76"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b7a778e5-abb3-46cb-bb39-e741b9cde7a6"
          x1="1270.48"
          y1="527.85"
          x2="1271.34"
          y2="636.06"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="bbd00fc3-7654-4042-970c-a933a5240a53"
          x1="1261.83"
          y1="517.03"
          x2="1262.77"
          y2="635.98"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="bbdb894c-6a9f-43c2-80ce-727a7a9b2180"
          x1="1279.14"
          y1="510"
          x2="1280.14"
          y2="636.06"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b24f983a-ff8a-4aee-b324-561a9f936498"
          x1="1253.17"
          y1="504.05"
          x2="1254.22"
          y2="635.81"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="e467504d-43e2-4e41-9edb-9885c61bfe61"
          x1="1244.52"
          y1="522.98"
          x2="1245.41"
          y2="635.58"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b22bcdc7-0809-4ee8-9fca-7fab90ac5d1a"
          x1="1227.2"
          y1="522.98"
          x2="1228.09"
          y2="634.64"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="ac4e9645-94d4-424f-b989-cd1484b3d4ec"
          x1="1235.86"
          y1="510"
          x2="1236.85"
          y2="635.14"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b98edb72-e641-4420-bc8e-80d0fa6ad9d5"
          x1="1296.45"
          y1="492.15"
          x2="1297.59"
          y2="635.97"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="af43ce8c-20b4-4a50-b7bb-2e569fee1e3f"
          x1="1279.14"
          y1="484.57"
          x2="1280.33"
          y2="634.95"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="a409fa29-b4e6-47bf-aaa9-fd585a8eeb98"
          x1="1253.17"
          y1="484.57"
          x2="1254.36"
          y2="634.95"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="b6f981e5-f550-48c4-997d-6c98d3e5e07d"
          x1="1218.55"
          y1="533.26"
          x2="1219.35"
          y2="634.01"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
        <linearGradient
          id="f49b43dd-7616-47f6-aa38-ec4c97e1f938"
          x1="1287.79"
          y1="527.85"
          x2="1288.65"
          y2="636.03"
          xlinkHref="#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe"
        />
      </defs>
      <g opacity="0.47">
        <path
          d="M1335.38,89.73a5.1,5.1,0,0,0,1.58-9.59c-4.38-2.19-10.15-3.12-15.19-1,15-6.41,22.6-14.24,12.82-21.36-7.83-5.69-19.93,14.95-22.78,14.95s1.42-8.54,7.83-16.37,5.69-14.23.71-16.37-13.52,1.42-15.66,23.49c0-3.56,1.43-25.62-4.27-23.49s-10,14.24-.71,27.05c-5.69,2.13-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.65,0,22.77,7.12,11.39-2.14,7.12-13.52-14.24-22.06-4.27,15,22.06,28.47,22.77C1296,95.35,1321.88,91.75,1335.38,89.73Z"
          fill="url(#e09de957-5abe-4ef1-ab62-470819d338d5)"
        />
        <path
          d="M1326.77,87.81c.5-4-7.08-8.09-13.15-3,9.1-8.09,11.12-14.67,6.57-14.67s-14.66,8.6-16.68,8.6,4.46-3.94,9-9.5,2.12-9.87-1.42-11.39c-3.32-1.42-13.38,1.78-16,15a2.29,2.29,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5,11.13,0,16.18,5.06,8.09-1.51,5.06-9.61-10.11-15.68-3,7.08,10.61,16.69,11.12S1326.77,87.81,1326.77,87.81Z"
          fill="#318099"
        />
        <path
          d="M1309.1,93.48c-1.9-.69,5.54-2.19,11.7-5.88s5.33-8.57,2.52-11.2c-2.64-2.46-13.19-2.87-20.11,8.71a2.3,2.3,0,0,1-2.07,1.11c-.83,0-1-2.27-1-2.27s1.58-17.83-6.11-17.38-8.52,8.76-5.48,15.23,2,9.32-3.14,4.24-5.61-12.77-13.72-8.16,3.07,12.38,11.93,16.11S1311,94.16,1309.1,93.48Z"
          fill="#318099"
        />
      </g>
      <g opacity="0.47">
        <path
          d="M453.05,177.1a5.1,5.1,0,0,0,1.58-9.59c-4.37-2.19-10.14-3.12-15.18-1,14.95-6.41,22.6-14.24,12.81-21.36-7.83-5.69-19.92,14.95-22.77,14.95s1.42-8.54,7.83-16.37,5.69-14.23.71-16.37-13.52,1.42-15.66,23.49c0-3.56,1.42-25.62-4.27-23.49s-10,14.24-.71,27c-5.69,2.13-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.65,0,22.77,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.27,14.94,22.06,28.47,22.77C413.67,182.72,439.56,179.12,453.05,177.1Z"
          fill="url(#efde8c08-3745-4f18-bed5-0c8104d3500e)"
        />
        <path
          d="M444.44,175.18c.51-4.05-7.07-8.09-13.14-3,9.1-8.08,11.12-14.66,6.57-14.66s-14.66,8.6-16.68,8.6,4.46-3.94,9-9.5,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.78-16,15a2.29,2.29,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.06,11.13,0,16.18,5.06,8.09-1.52,5.06-9.6-10.11-15.67-3,7.08,10.61,16.68,11.12S444.44,175.18,444.44,175.18Z"
          fill="#318099"
        />
        <path
          d="M426.78,180.85c-1.9-.69,5.53-2.19,11.7-5.88s5.33-8.57,2.52-11.2c-2.64-2.46-13.2-2.87-20.11,8.71a2.31,2.31,0,0,1-2.07,1.11c-.83,0-1-2.27-1-2.27s1.59-17.83-6.1-17.38-8.53,8.76-5.48,15.23,2,9.32-3.14,4.24-5.61-12.77-13.72-8.16,3.06,12.38,11.93,16.11S428.68,181.53,426.78,180.85Z"
          fill="#318099"
        />
      </g>
      <g id="f0448b0f-e355-4eba-99ac-766319028975" data-name="decor">
        <path
          d="M1007.72,74.06c-1.8-4.45-5.55-13.2-4.3-20.56s2.64-16.54.83-19.31"
          fill="#3499c1"
        />
        <path
          d="M1011.75,23.07c1.39,4.59,2.22,5,0,10.42s-6.39,20.29-6.25,23.34S1009.25,72,1009.25,72"
          fill="#3499c1"
        />
        <path
          d="M1013.14,45.86c1,1.66-1,6.53-3.89,11s-3.75,17.23-3.75,17.23"
          fill="#3499c1"
        />
        <path
          d="M1003.14,16.54c-.56-2.5-2.64-1.95-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.33s-3.75-1.8.28,3.76c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31,3.95-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.62,0-5.7c.14-1,3.33-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64A5.29,5.29,0,0,0,1003.14,16.54Z"
          fill="#3499c1"
        />
        <path
          d="M1005.3,40.44s4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.62,0-5.7c.14-1,3.34-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64a5.29,5.29,0,0,0-1-2.92"
          fill="#3499c1"
        />
        <path
          d="M1005.36,40.44s1.53-7.64-.14-8.89-2.64-.56-2.64-.56,3.48-6.67.42-4.31c.14-1,2.5-5.42,0-4.58.14-.7.14-4.87-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
          fill="#3499c1"
        />
        <path
          d="M1003.14,16.54c-.56-2.5-2.64-1.95-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.33s-3.75-1.8.28,3.76c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31"
          fill="#3499c1"
        />
        <path
          d="M1010.36,1.67c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.69-2.64,1,.55,3.47-.28.56-2.36.56-1,2.5s5.78,4.31,5.78,4.31,3.94-7.64,2.28-8.89-2.23.83-2.23.83,3.48-8.61,0-5.69c.14-1,3.34-6.26,0-4.59.42-1.53,1.39-6.53-1.39-2.64A5.24,5.24,0,0,0,1010.36,1.67Z"
          fill="#3499c1"
        />
        <path
          d="M1012.53,25.57s4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.61,0-5.69c.13-1,3.33-6.26,0-4.59C1013,5.7,1014,.7,1011.2,4.59a5.29,5.29,0,0,0-1-2.92"
          fill="#3499c1"
        />
        <path
          d="M1012.59,25.57s1.52-7.64-.14-8.89-2.64-.56-2.64-.56,3.47-6.67.41-4.3c.14-1,2.5-5.42,0-4.59.14-.69.14-4.86-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
          fill="#3499c1"
        />
        <path
          d="M1010.36,1.67c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.69-2.64,1,.55,3.47-.28.56-2.36.56-1,2.5s5.78,4.31,5.78,4.31"
          fill="#3499c1"
        />
        <path
          d="M1019.88,23.73c.34-2.54-1.81-2.73-2.22-.81s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.41-2.81,0-.67,3.45-.45.43-2.41-.29-1.77,2s3.94,6,3.94,6,6.34-5.82,5.2-7.57-2.37,0-2.37,0,6.22-6.9,2-5.35c.47-.87,5.28-4.73,1.58-4.31.91-1.29,3.55-5.65-.4-3A5.28,5.28,0,0,0,1019.88,23.73Z"
          fill="#3499c1"
        />
        <path
          d="M1013.7,46.92s6.34-5.82,5.2-7.57-2.37,0-2.37,0,6.22-6.89,2-5.35c.47-.86,5.28-4.72,1.58-4.3.91-1.3,3.55-5.66-.4-3a5.25,5.25,0,0,0,.09-3.07"
          fill="#3499c1"
        />
        <path
          d="M1013.76,46.94s4.06-6.65,2.92-8.4-2.29-1.43-2.29-1.43,5.56-5.07,1.87-3.9c.47-.86,4.21-4.23,1.58-4.3.37-.61,1.8-4.52.2-3.78a16.68,16.68,0,0,1,1.05-2.87"
          fill="#3499c1"
        />
        <path
          d="M1019.88,23.73c.34-2.54-1.81-2.73-2.22-.81s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.41-2.81,0-.67,3.45-.45.43-2.41-.29-1.77,2s3.94,6,3.94,6"
          fill="#3499c1"
        />
      </g>
      <path
        d="M636.4,50.4c-3.12,1.59-5.53,3.6-5.72,6.79S630,63,628.31,63.36c-.47.67.07,1,.07,1s2.77-.07,3.37,1.22A6.38,6.38,0,0,0,639,68.48c-.88-.34-4.65-.44-4-3.14s2.6-2.6,2.6-2.6.4,2.46,1.18,3,3.34-.22,3.34-.22-1.95.18-2-1.08-.24-3.74-1.28-3.67.3.15,1.17-1.46-.16-3.4,1.46-4.2c-3.49.52-3.87,4.36-3.87,4.36l-1.44.09s-2-1-2.2-2.68a22.69,22.69,0,0,1,.33-4.59Z"
        fill="#314e60"
        opacity="0.33"
      />
      <path
        d="M174.66,69.83c-4.56,3.46-7.85,7.37-7.25,12.54s.59,9.43-2,10.57c-.58,1.2.38,1.55.38,1.55s4.42-.91,5.76,1A10.41,10.41,0,0,0,184,98.11c-1.53-.3-7.59.62-7.26-3.92s3.43-4.91,3.43-4.91,1.33,3.83,2.77,4.54,5.28-1.31,5.28-1.31-3.07.86-3.57-1.15-1.47-5.92-3.11-5.52.53.16,1.47-2.68-1.24-5.4,1.13-7.15c-5.45,1.83-5,8.1-5,8.1l-2.28.56s-3.55-1.06-4.3-3.68a37.57,37.57,0,0,1-.78-7.45Z"
        fill="#314e60"
        opacity="0.68"
      />
      <path
        d="M448.71,37.67c7.81,3.35,14,7.81,14.93,15.49s2.51,13.81,6.7,14.51c1.25,1.53,0,2.37,0,2.37s-6.7.28-8,3.49-7,9.91-17,8.23c2.09-1,11.16-1.81,9.07-8.23s-6.7-5.86-6.7-5.86-.56,6-2.37,7.53-8.09,0-8.09,0,4.74.14,4.74-2.93,0-9.07,2.51-9.07-.69.42-3.07-3.34-.14-8.24-4.18-9.91c8.51.7,10,9.91,10,9.91h3.49s4.75-2.8,4.89-6.84-1.54-11-1.54-11Z"
        fill="#314e60"
      />
      <path
        d="M30.68,41.05C19.87,45.68,11.38,51.85,10,62.46S6.56,81.57.77,82.53c-1.73,2.12,0,3.28,0,3.28s9.26.39,11,4.82,9.65,13.7,23.54,11.39c-2.9-1.35-15.44-2.51-12.54-11.39S32,82.53,32,82.53s.77,8.3,3.28,10.42S46.5,93,46.5,93s-6.56.19-6.56-4,0-12.54-3.47-12.54,1,.58,4.24-4.63S40.9,60.34,46.5,58c-11.77,1-13.89,13.7-13.89,13.7H27.78S21.22,67.87,21,62.27,23.15,47,23.15,47Z"
        fill="#314e60"
      />
      <g>
        <g opacity="0.32">
          <path
            d="M994.87,99s14.62-11.62,16.3-17,4-5.47,1.87-6.31c-6.3-2.51-4.7-10.23,9.44-5.48,17.64,5.94,16.13,13.17,2.9,11.16-3.23,2.19-4.33,3.67-6,4.86-1.32,1,2.07,8.25-21.49,15.82Z"
            fill="#a13172"
          />
          <ellipse
            cx="1022.84"
            cy="75.31"
            rx="2.98"
            ry="10.39"
            transform="matrix(0.32, -0.95, 0.95, 0.32, 626.6, 1021.28)"
            fill="#a13172"
          />
          <path
            d="M1012.67,92.23c4.39-.56,7.55-2.14,10.52-2.78s6.21-3.28,9.36-4.41S1045.87,81.21,1042,73c-4.74-3.66.89-8,13.73-3.63s15.1,8,12.16,9.86c-1.94,1.25-2.52,6.07-15.15,7.17s-19,3.7-19.9,4.67-3.58,6.17-13.44,8-23.31,3.48-23.31,3.48Z"
            fill="#a13172"
          />
          <ellipse
            cx="1055.24"
            cy="74.19"
            rx="2.98"
            ry="10.39"
            transform="translate(649.76 1051.24) rotate(-71.48)"
            fill="#a13172"
          />
          <path
            d="M1025.89,94.7c4.45-.73,11.65.64,16.86.9,2.34.12,5.61.68,9,1,5.31.53,9.86-1.14,11-4,1.37-3.33,8.46-5.4,13.2-.42,4.45,4.68,7.36,10.42,2.87,13.4-2.38,1.58-6.55.58-9.25-1.06a15.6,15.6,0,0,0-8.42-1.93,42.82,42.82,0,0,1-12.75-1.19c-4.89-1.09-19.56-1.83-33.3,2.26-13.91,4.12-16.6,1.85-16.83,1.17a22.22,22.22,0,0,1-.43-2.72Z"
            fill="#a13172"
          />
          <ellipse
            cx="1072.81"
            cy="98.16"
            rx="4.25"
            ry="7.27"
            transform="translate(170.55 686.78) rotate(-38.35)"
            fill="#a13172"
          />
          <path
            d="M1024.12,97.79a17.47,17.47,0,0,0,8.75-6.73c.85-1,7.28-3.56,19.9-4.67,10.35-.9,12.7-4.1,13.81-6.12A27.78,27.78,0,0,1,1054,79.21c1.92,2.17,2.79,3.28-.9,4.56s-5.55-.62-15.69,4.15-9.18,8.24-15.88,9c-4.52.49-13.27,3.12-18.49,4.78,2.37-.32,5.14-.72,8-1.16Z"
            fill="#a13172"
            opacity="0.47"
          />
          <g>
            <path
              d="M1042.21,73.41c1.17,2.8.69,4.94-.56,6.58,3.33-2.19,8.47-2,8.47-2A29.48,29.48,0,0,1,1042.21,73.41Z"
              fill="#a13172"
              opacity="0.47"
            />
            <polygon
              points="1039.83 81.73 1039.83 81.73 1039.83 81.73 1039.83 81.73"
              fill="#a13172"
            />
          </g>
          <path
            d="M1015.16,103.65c13.74-4.09,28.41-3.35,33.3-2.26,7.13,2,16.92.65,20.74,2.4,0,0-4.2-3.64-4.76-6-1,2.81-2,3.79-7.85,3.83s-7.58-1.24-13.13-1.85A101.67,101.67,0,0,0,1025,100c-4,.47-17.18,4.69-20.26,4.76s-6.45.07-6.45.07l3.1,1.21C1003.85,106.2,1008,105.76,1015.16,103.65Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1000.66,96c3.21-.85,2.79-4.47,7.2-6.83s3.69-4.7,5.68-7.46,2.94-2.27,5.32-3a16.5,16.5,0,0,1-5-2.11h0c-.18.68-1.57,1.92-2.69,5.49-1.68,5.36-16.3,17-16.3,17C996.41,98.77,997.45,96.86,1000.66,96Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1016.09,93.42c2.9-.48,9.51-3.12,11.84-4.18s13.1-5.41,12.53-6.45a8.6,8.6,0,0,0-.68-1,21.5,21.5,0,0,1-5.38,2.63h0s-4.58,2.29-8,3.8a13.09,13.09,0,0,1-3.18,1.25l-.87.21c-2.72.72-1.18,1.09-5.15,1.6C1015.5,92.3,1013.18,93.89,1016.09,93.42Z"
            fill="#a13172"
          />
          <path
            d="M1077.32,97.35c-1.69-3.18-4.88-5.59-7.39-5.47a2.7,2.7,0,0,0-2.63,2.42C1070.59,92.35,1075.12,95.5,1077.32,97.35Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1057.21,71.73c-5.36-2-10.58-2.48-11.67-1.12-.38.48-.17,1.14.46,1.86,1.58-3.32,16.84,2.47,17.9,2.88A21.83,21.83,0,0,0,1057.21,71.73Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1024.05,72.84l-1-.57c-4.71-1.48-9-1.75-9.94-.54-.46.57-.08,1.39.87,2.28.29-.09,1,.3,2.43,1.71l.27.16C1013.45,70.29,1024.05,72.84,1024.05,72.84Z"
            fill="#a13172"
            opacity="0.47"
          />
        </g>
        <g>
          <path
            d="M992.37,103.58s-9-20.1-14.73-25.47-5.13-7.23-6.75-6.24c-4.86,2.95-13.34-4.16-3.47-11.44,12.33-9.08,20.27-2.42,13.86,6.24,1.56,4.16,2.94,6.13,3.81,8.32.7,1.73,10.22,4.68,11.78,28.59Z"
            fill="#64cc2b"
          />
          <ellipse
            cx="973.4"
            cy="63.99"
            rx="8.58"
            ry="4.07"
            transform="translate(127.76 550.29) rotate(-33.66)"
            fill="#170"
          />
          <path
            d="M989.94,84.69c.7-3.81-.17-7.45,0-10.22s-1.9-7.28-2.25-10.57-.35-13.17-11.09-16.46c-5.7.87-9-6.76,0-13.34s13.91-5.59,15.21-1.88c.86,2.45,6.28,6.56,3.68,17.13s-1.56,17.5-.7,18.88,6.07,7.45,5.2,16.46-3.12,20.62-3.12,20.62Z"
            fill="#64cc2b"
          />
          <ellipse
            cx="982.06"
            cy="38.17"
            rx="8.58"
            ry="4.07"
            transform="translate(143.52 550.77) rotate(-33.66)"
            fill="#170"
          />
          <path
            d="M996.87,76.37c.52-4,4.34-8.49,6.24-12.3.86-1.71,2.52-3.81,4-6.16a9.57,9.57,0,0,0-1.29-11.59c-3.45-3.59-3.68-10.62,3.57-10.49,6.81.13,14.38,2.26,16.46,8,1.1,3-1.34,5.5-4.07,6.33a7.53,7.53,0,0,0-4.83,5,20.46,20.46,0,0,1-5.31,8.92c-2.77,3-8.14,13.69-7.62,27.38.52,13.86-3,14.2-3.81,13.86s-3.3-1.73-3.3-1.73Z"
            fill="#64cc2b"
          />
          <ellipse
            cx="1015.33"
            cy="42.85"
            rx="4.07"
            ry="8.58"
            transform="translate(671.69 999.22) rotate(-72.65)"
            fill="#170"
          />
          <path
            d="M999.93,80.1c-.81-6.46-4.43-10.73-5.14-11.87-.86-1.38-1.9-8.31.7-18.88,2.13-8.67-.86-12.91-2.87-15.3a13.78,13.78,0,0,1-5.1,8.89c3.12.17,4.68.34,5,4.15s-2.42,3.82,0,15.25,6.76,13.34,5.55,19.06c-.82,3.85-.46,12.6-.13,17.88.35-2.07.74-4.51,1.1-7Z"
            fill="#11366d"
            opacity="0.47"
          />
          <g>
            <path
              d="M977.15,47.62a14.28,14.28,0,0,1,7.47,5.43,11.31,11.31,0,0,1,.3-8A19.38,19.38,0,0,1,977.15,47.62Z"
              fill="#11366d"
              opacity="0.47"
            />
            <polygon
              points="986.09 55.79 986.09 55.79 986.09 55.79 986.09 55.79"
              fill="#170"
            />
          </g>
          <path
            d="M1004,91.45c-.52-13.69,4.85-24.43,7.62-27.38,4.5-4,5.95-12.54,9.17-14.15,0,0-5.53.47-8.48-.92,3,3,3.77,4.46,2,9s-3.77,4.9-6.19,8.71-4.68,10.92-5.38,14.38.18,16.81-.69,19.23-1.9,5-1.9,5l2.35-1.48C1003.46,102.1,1004.24,98.55,1004,91.45Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M990.64,96.82c0-3.12-4.33-5.55-5.72-10.74s-4.33-6.41-6.93-10-1.73-4-1.91-6.41a9.14,9.14,0,0,1-4,2.24h0a55.32,55.32,0,0,0,5.54,6.25c5.72,5.37,14.73,25.47,14.73,25.47C992.54,102.19,990.64,99.94,990.64,96.82Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M992.37,83c.35-2.6-.69-9.7-1.21-12.3s-2.26-14.21-3.64-14.56a13.1,13.1,0,0,0-1.4-.25,22,22,0,0,1,1.4,6.14h0s1.25,5.27,2,9.08a11.66,11.66,0,0,1,.47,3.4c0,.24,0,.52,0,.83,0,2.65.91,1.74.28,5.18C990.89,82.56,992,85.56,992.37,83Z"
            fill="#86e04b"
          />
          <path
            d="M1015.78,38.76c-4.22-1.11-8-.49-8.64,1.53-.37,1.19.45,2.61,2,3.87C1007.89,40.14,1013,39.05,1015.78,38.76Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M979.8,34.78c-3.94,2.63-6.12,6.27-4.88,8.15a2.81,2.81,0,0,0,2.3,1c-3.38-3.74,8-11.1,8.85-11.6A13.76,13.76,0,0,0,979.8,34.78Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M970.9,61.18l-1,.31c-3.16,2.5-4.79,5.58-3.68,7.25a3.16,3.16,0,0,0,2.91,1.06c0-.29.65-.53,2.74-.57l.28-.09C964.68,67.41,970.9,61.18,970.9,61.18Z"
            fill="#11366d"
            opacity="0.47"
          />
        </g>
        <path
          d="M1007.61,49a6.5,6.5,0,0,1,.92,3.3,12.11,12.11,0,0,1-.39,3.45,21.82,21.82,0,0,1-2.83,6.27c-1.2,1.88-2.39,3.77-3.63,5.62s-2.5,3.71-3.83,5.53a47.26,47.26,0,0,1,2.74-6.17c1-2,2.18-3.92,3.36-5.83a30.49,30.49,0,0,0,3-5.78,14.59,14.59,0,0,0,.8-3.12A7.87,7.87,0,0,0,1007.61,49Z"
          fill="#86e04b"
        />
        <path
          d="M1010.31,36.24c-.91.52-1.78,1-2.57,1.48a5.3,5.3,0,0,0-1.82,1.71,2.66,2.66,0,0,0-.06,2.21,23.46,23.46,0,0,0,1.23,2.65,5.89,5.89,0,0,1-2.36-2.11,3.72,3.72,0,0,1-.6-1.65,3.21,3.21,0,0,1,.38-1.87,4.73,4.73,0,0,1,2.69-2.07A6.74,6.74,0,0,1,1010.31,36.24Z"
          fill="#86e04b"
        />
        <path
          d="M975.94,37.05c-.56.88-1.12,1.69-1.58,2.5a5.36,5.36,0,0,0-.81,2.37,2.65,2.65,0,0,0,1,2,21.93,21.93,0,0,0,2.32,1.76,5.87,5.87,0,0,1-3.07-.75,3.67,3.67,0,0,1-1.3-1.19,3.18,3.18,0,0,1-.54-1.82,4.73,4.73,0,0,1,1.41-3.09A6.9,6.9,0,0,1,975.94,37.05Z"
          fill="#86e04b"
        />
        <path
          d="M966.87,62c-.47,1-.91,1.9-1.24,2.81a5.77,5.77,0,0,0-.41,2.61,3.55,3.55,0,0,0,1.18,2.16,2.68,2.68,0,0,0,.54.46l.58.48a12.26,12.26,0,0,1,1.29.91,12.8,12.8,0,0,1-1.62-.2,7.19,7.19,0,0,1-1.55-.65,4,4,0,0,1-2-3,5.11,5.11,0,0,1,.89-3.38A6.74,6.74,0,0,1,966.87,62Z"
          fill="#86e04b"
        />
      </g>
      <g>
        <g>
          <path
            d="M1064.68,205.73s-2.78-6.18-4.54-7.84-1.57-2.22-2.07-1.92c-1.5.91-4.11-1.28-1.07-3.52,3.79-2.79,6.24-.74,4.26,1.92.48,1.28.91,1.89,1.18,2.56s3.14,1.44,3.62,8.8Z"
            fill="#318099"
          />
          <ellipse
            cx="1058.84"
            cy="193.55"
            rx="2.64"
            ry="1.25"
            transform="matrix(0.83, -0.55, 0.55, 0.83, 70.27, 619.38)"
            fill="#318099"
          />
          <path
            d="M1063.93,199.92a20.59,20.59,0,0,0,0-3.15c0-.85-.59-2.24-.69-3.25s-.11-4.05-3.41-5.06c-1.76.26-2.78-2.08,0-4.11s4.27-1.72,4.67-.58c.27.76,1.94,2,1.14,5.27s-.48,5.39-.22,5.81a7.34,7.34,0,0,1,1.6,5.07c-.26,2.77-1,6.34-1,6.34Z"
            fill="#318099"
          />
          <ellipse
            cx="1061.5"
            cy="185.6"
            rx="2.64"
            ry="1.25"
            transform="translate(75.12 619.52) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1066.06,197.36c.16-1.23,1.34-2.61,1.92-3.79.27-.52.78-1.17,1.22-1.89a2.94,2.94,0,0,0-.4-3.57c-1.06-1.1-1.13-3.27,1.1-3.23s4.43.7,5.07,2.46a1.56,1.56,0,0,1-1.25,1.94,2.31,2.31,0,0,0-1.49,1.55,6.24,6.24,0,0,1-1.63,2.74c-.86.91-2.51,4.22-2.35,8.43s-.91,4.37-1.17,4.26-1-.53-1-.53Z"
            fill="#318099"
          />
          <ellipse
            cx="1071.74"
            cy="187.04"
            rx="1.25"
            ry="2.64"
            transform="translate(573.65 1154.27) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1067,198.51a8,8,0,0,0-1.58-3.66c-.26-.42-.58-2.56.22-5.81.65-2.66-.27-4-.89-4.71a4.2,4.2,0,0,1-1.57,2.74c1,.05,1.44.11,1.55,1.28s-.75,1.17,0,4.69,2.08,4.11,1.71,5.87a28.51,28.51,0,0,0,0,5.5c.11-.64.23-1.39.34-2.17Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1060,188.51a4.39,4.39,0,0,1,2.3,1.67,3.54,3.54,0,0,1,.09-2.47A5.79,5.79,0,0,1,1060,188.51Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1062.75 191.02 1062.75 191.02 1062.75 191.02 1062.75 191.02"
              fill="#318099"
            />
          </g>
          <path
            d="M1068.25,202c-.16-4.21,1.49-7.52,2.35-8.43,1.38-1.22,1.83-3.86,2.82-4.35a6.71,6.71,0,0,1-2.61-.28,2,2,0,0,1,.63,2.75c-.54,1.39-1.16,1.51-1.91,2.68a16,16,0,0,0-1.65,4.43c-.22,1.07,0,5.17-.22,5.92s-.58,1.54-.58,1.54l.72-.45A8,8,0,0,0,1068.25,202Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.14,203.65c0-1-1.33-1.7-1.76-3.3s-1.33-2-2.13-3.1a2.31,2.31,0,0,1-.58-2,2.89,2.89,0,0,1-1.23.69h0a16.37,16.37,0,0,0,1.7,1.92c1.76,1.66,4.54,7.84,4.54,7.84C1064.73,205.31,1064.14,204.61,1064.14,203.65Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.68,199.39a18.74,18.74,0,0,0-.38-3.79c-.16-.8-.69-4.37-1.12-4.48a4,4,0,0,0-.43-.08,6.7,6.7,0,0,1,.43,1.89h0s.39,1.63.61,2.8a3.83,3.83,0,0,1,.14,1,2.44,2.44,0,0,1,0,.26c0,.81.28.54.09,1.6C1064.22,199.26,1064.57,200.19,1064.68,199.39Z"
            fill="#318099"
          />
          <path
            d="M1071.88,185.79c-1.3-.35-2.46-.16-2.66.47-.11.36.14.8.62,1.19C1069.46,186.21,1071,185.87,1071.88,185.79Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1060.81,184.56c-1.21.81-1.89,1.93-1.5,2.51a.87.87,0,0,0,.71.32c-1-1.15,2.47-3.41,2.72-3.57A4.22,4.22,0,0,0,1060.81,184.56Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1058.07,192.68l-.3.1c-1,.77-1.47,1.72-1.13,2.23a1,1,0,0,0,.9.33c0-.09.2-.17.84-.18l.09,0C1056.16,194.6,1058.07,192.68,1058.07,192.68Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1069.37,189s.72,1.26-.83,3.73-2.18,3.7-2.18,3.7"
          fill="#318099"
        />
        <path d="M1070.2,185s-3,.49-1,2.47" fill="#318099" />
        <path d="M1059.62,185.26s-2.39,1.82.28,2.65" fill="#318099" />
        <path d="M1056.83,192.93s-2.08,2.07.6,2.9" fill="#318099" />
      </g>
      <g>
        <g>
          <path
            d="M1224.09,186.54s-3.55-7.91-5.8-10-2-2.85-2.67-2.46c-1.91,1.16-5.25-1.64-1.36-4.5,4.86-3.58,8-1,5.46,2.45.61,1.64,1.16,2.42,1.5,3.28.27.68,4,1.84,4.64,11.26Z"
            fill="#318099"
          />
          <ellipse
            cx="1216.61"
            cy="170.95"
            rx="3.38"
            ry="1.6"
            transform="translate(109.26 703.04) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1223.13,179.1a25.54,25.54,0,0,0,0-4c.07-1.1-.75-2.87-.89-4.17s-.13-5.19-4.36-6.48c-2.25.34-3.55-2.67,0-5.26s5.47-2.2,6-.74c.34,1,2.47,2.58,1.45,6.75s-.62,6.89-.28,7.44a9.33,9.33,0,0,1,2,6.48c-.34,3.55-1.23,8.13-1.23,8.13Z"
            fill="#318099"
          />
          <ellipse
            cx="1220.03"
            cy="160.77"
            rx="3.38"
            ry="1.6"
            transform="translate(115.47 703.23) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1225.86,175.83c.21-1.57,1.71-3.35,2.46-4.85.34-.68,1-1.5,1.56-2.43a3.78,3.78,0,0,0-.51-4.57c-1.36-1.41-1.45-4.18,1.41-4.13,2.68.05,5.66.89,6.48,3.14a2,2,0,0,1-1.6,2.5,2.93,2.93,0,0,0-1.9,2,8.23,8.23,0,0,1-2.09,3.52c-1.1,1.16-3.21,5.39-3,10.79s-1.16,5.59-1.5,5.46-1.3-.69-1.3-.69Z"
            fill="#318099"
          />
          <ellipse
            cx="1233.13"
            cy="162.62"
            rx="1.6"
            ry="3.38"
            transform="translate(710.24 1291.17) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1227.07,177.29a10.09,10.09,0,0,0-2-4.67c-.34-.55-.75-3.28.28-7.44.84-3.42-.34-5.09-1.13-6a5.5,5.5,0,0,1-2,3.5c1.23.07,1.84.14,2,1.64s-1,1.5,0,6,2.66,5.25,2.18,7.51a36.35,36.35,0,0,0,0,7c.14-.82.29-1.78.44-2.77Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1218.09,164.5a5.54,5.54,0,0,1,2.94,2.14,4.52,4.52,0,0,1,.12-3.17A7.55,7.55,0,0,1,1218.09,164.5Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1221.62 167.71 1221.62 167.71 1221.62 167.71 1221.62 167.71"
              fill="#318099"
            />
          </g>
          <path
            d="M1228.66,181.77c-.2-5.4,1.91-9.63,3-10.79,1.77-1.57,2.34-4.94,3.61-5.58a8.34,8.34,0,0,1-3.34-.36c1.16,1.16,1.48,1.76.8,3.53s-1.48,1.93-2.44,3.43a20.84,20.84,0,0,0-2.12,5.67c-.27,1.36.07,6.62-.27,7.58s-.75,2-.75,2l.93-.58C1228.46,186,1228.77,184.56,1228.66,181.77Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1223.41,183.88c0-1.23-1.71-2.18-2.26-4.23s-1.7-2.53-2.73-4a3,3,0,0,1-.75-2.53,3.55,3.55,0,0,1-1.57.89h0a22.3,22.3,0,0,0,2.19,2.46c2.25,2.12,5.8,10,5.8,10C1224.16,186,1223.41,185.11,1223.41,183.88Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1224.09,178.42a23.53,23.53,0,0,0-.48-4.85c-.2-1-.89-5.59-1.43-5.73a4.44,4.44,0,0,0-.56-.1,8.73,8.73,0,0,1,.56,2.42h0s.49,2.08.77,3.58a4.55,4.55,0,0,1,.18,1.34c0,.09,0,.2,0,.32,0,1,.36.69.11,2C1223.51,178.26,1224,179.44,1224.09,178.42Z"
            fill="#318099"
          />
          <path
            d="M1233.31,161c-1.66-.44-3.15-.2-3.4.6-.15.47.18,1,.79,1.52C1230.21,161.55,1232.2,161.12,1233.31,161Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1219.14,159.44c-1.56,1-2.42,2.47-1.93,3.21a1.11,1.11,0,0,0,.91.41c-1.33-1.47,3.17-4.37,3.49-4.57A5.33,5.33,0,0,0,1219.14,159.44Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1215.63,169.84l-.38.12c-1.25,1-1.89,2.2-1.45,2.86a1.23,1.23,0,0,0,1.15.41c0-.11.25-.2,1.08-.22l.11,0C1213.18,172.3,1215.63,169.84,1215.63,169.84Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1230.09,165.05s.93,1.62-1.06,4.79-2.78,4.74-2.78,4.74"
          fill="#318099"
        />
        <path d="M1231.16,160s-3.81.64-1.27,3.17" fill="#318099" />
        <path d="M1217.62,160.33s-3.07,2.34.35,3.4" fill="#318099" />
        <path d="M1214,170.16s-2.66,2.65.77,3.71" fill="#318099" />
      </g>
      <g>
        <g>
          <path
            d="M1223.22,75.86s-3-6.7-4.91-8.5-1.71-2.41-2.26-2.08c-1.61,1-4.44-1.38-1.15-3.81,4.11-3,6.76-.81,4.62,2.08.52,1.39,1,2,1.27,2.77s3.41,1.56,3.93,9.54Z"
            fill="#318099"
          />
          <ellipse
            cx="1216.89"
            cy="62.66"
            rx="2.86"
            ry="1.36"
            transform="translate(169.33 685.04) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1222.41,69.56a22.7,22.7,0,0,0,0-3.41c.06-.92-.64-2.43-.75-3.52s-.12-4.39-3.7-5.49c-1.9.29-3-2.25,0-4.45s4.64-1.86,5.07-.63c.29.82,2.09,2.19,1.23,5.71s-.52,5.84-.23,6.3a8,8,0,0,1,1.73,5.49c-.29,3-1,6.87-1,6.87Z"
            fill="#318099"
          />
          <ellipse
            cx="1219.78"
            cy="54.05"
            rx="2.86"
            ry="1.36"
            transform="translate(174.58 685.2) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1224.72,66.79c.17-1.33,1.44-2.83,2.08-4.11.29-.57.84-1.27,1.32-2a3.2,3.2,0,0,0-.43-3.87c-1.15-1.19-1.23-3.54,1.19-3.49,2.27,0,4.8.75,5.49,2.65A1.69,1.69,0,0,1,1233,58a2.53,2.53,0,0,0-1.61,1.68,6.75,6.75,0,0,1-1.77,3c-.92,1-2.71,4.57-2.54,9.13s-1,4.74-1.27,4.62-1.1-.57-1.1-.57Z"
            fill="#318099"
          />
          <ellipse
            cx="1230.87"
            cy="55.61"
            rx="1.36"
            ry="2.86"
            transform="matrix(0.3, -0.95, 0.95, 0.3, 810.79, 1213.91)"
            fill="#318099"
          />
          <path
            d="M1225.74,68a8.66,8.66,0,0,0-1.71-4c-.29-.46-.64-2.77.23-6.3.71-2.89-.29-4.3-1-5.1a4.62,4.62,0,0,1-1.7,3c1,0,1.56.11,1.68,1.38s-.81,1.27,0,5.09,2.25,4.45,1.84,6.35a30.87,30.87,0,0,0,0,6c.12-.69.25-1.5.37-2.34Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1218.14,57.2a4.71,4.71,0,0,1,2.49,1.81,3.82,3.82,0,0,1,.1-2.68A6.43,6.43,0,0,1,1218.14,57.2Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1221.13 59.92 1221.13 59.92 1221.13 59.92 1221.13 59.92"
              fill="#318099"
            />
          </g>
          <path
            d="M1227.09,71.81c-.17-4.56,1.62-8.14,2.54-9.13,1.5-1.32,2-4.18,3.06-4.72a7.15,7.15,0,0,1-2.83-.3c1,1,1.26,1.48.68,3s-1.26,1.63-2.06,2.9a17.75,17.75,0,0,0-1.8,4.8c-.23,1.15.06,5.6-.23,6.41s-.63,1.67-.63,1.67l.78-.49C1226.92,75.37,1227.18,74.18,1227.09,71.81Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1222.64,73.6c0-1-1.44-1.84-1.91-3.58s-1.44-2.14-2.31-3.35a2.53,2.53,0,0,1-.63-2.14,3.05,3.05,0,0,1-1.33.75h0a17.72,17.72,0,0,0,1.85,2.08c1.9,1.8,4.91,8.5,4.91,8.5C1223.28,75.39,1222.64,74.64,1222.64,73.6Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1223.22,69a19.73,19.73,0,0,0-.41-4.1c-.17-.87-.75-4.74-1.21-4.85a3.2,3.2,0,0,0-.47-.09,7.24,7.24,0,0,1,.47,2.05h0s.42,1.76.65,3a3.78,3.78,0,0,1,.16,1.13c0,.08,0,.17,0,.28,0,.88.3.58.09,1.73C1222.73,68.85,1223.1,69.85,1223.22,69Z"
            fill="#318099"
          />
          <path
            d="M1231,54.24c-1.4-.37-2.67-.16-2.88.51-.12.4.15.87.67,1.3C1228.4,54.7,1230.08,54.34,1231,54.24Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1219,52.92c-1.32.87-2,2.09-1.63,2.71a1,1,0,0,0,.77.36c-1.13-1.25,2.68-3.71,2.95-3.87A4.5,4.5,0,0,0,1219,52.92Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1216.06,61.72l-.32.1c-1.06.84-1.6,1.86-1.23,2.42a1.06,1.06,0,0,0,1,.35c0-.09.22-.17.92-.18l.09,0C1214,63.8,1216.06,61.72,1216.06,61.72Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path d="M1228.3,57.67s.78,1.37-.9,4-2.35,4-2.35,4" fill="#318099" />
        <path d="M1229.2,53.4s-3.22.54-1.07,2.69" fill="#318099" />
        <path d="M1217.74,53.67s-2.6,2,.3,2.88" fill="#318099" />
        <path d="M1214.72,62s-2.26,2.24.64,3.14" fill="#318099" />
      </g>
      <g>
        <g>
          <path
            d="M1074.61,71.72s-4.15-9.25-6.78-11.72-2.36-3.32-3.11-2.87c-2.23,1.36-6.13-1.91-1.59-5.26,5.67-4.18,9.32-1.11,6.38,2.87.71,1.91,1.35,2.82,1.75,3.83.32.79,4.7,2.15,5.42,13.15Z"
            fill="#318099"
          />
          <ellipse
            cx="1065.88"
            cy="53.51"
            rx="3.94"
            ry="1.87"
            transform="translate(149.08 599.8) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1073.49,63c.32-1.75-.08-3.43,0-4.7s-.88-3.35-1-4.86-.15-6.06-5.1-7.57c-2.62.4-4.14-3.11,0-6.14s6.4-2.57,7-.86c.39,1.12,2.89,3,1.69,7.87s-.72,8-.32,8.69a11,11,0,0,1,2.39,7.57c-.4,4.14-1.43,9.48-1.43,9.48Z"
            fill="#318099"
          />
          <ellipse
            cx="1069.86"
            cy="41.63"
            rx="3.94"
            ry="1.87"
            transform="translate(156.33 600.02) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1076.68,59.2c.24-1.83,2-3.9,2.87-5.65.39-.79,1.15-1.76,1.82-2.84a4.41,4.41,0,0,0-.6-5.33c-1.58-1.65-1.69-4.88,1.65-4.82,3.13.06,6.61,1,7.57,3.66.5,1.4-.62,2.53-1.88,2.91a3.47,3.47,0,0,0-2.22,2.31,9.36,9.36,0,0,1-2.44,4.11c-1.27,1.35-3.74,6.29-3.5,12.59s-1.36,6.53-1.76,6.37-1.51-.79-1.51-.79Z"
            fill="#318099"
          />
          <ellipse
            cx="1085.16"
            cy="43.78"
            rx="1.87"
            ry="3.94"
            transform="translate(719.82 1066.54) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1078.08,60.92a11.79,11.79,0,0,0-2.36-5.46c-.4-.64-.87-3.83.32-8.69,1-4-.4-5.93-1.32-7a6.27,6.27,0,0,1-2.35,4.08c1.44.08,2.16.16,2.32,1.92s-1.12,1.75,0,7,3.1,6.14,2.55,8.77a42.07,42.07,0,0,0-.06,8.22c.16-.95.34-2.08.51-3.24Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1067.61,46a6.53,6.53,0,0,1,3.43,2.5,5.21,5.21,0,0,1,.14-3.7A8.71,8.71,0,0,1,1067.61,46Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1071.72 49.73 1071.72 49.73 1071.72 49.73 1071.72 49.73"
              fill="#318099"
            />
          </g>
          <path
            d="M1080,66.14c-.24-6.3,2.23-11.24,3.5-12.59,2.07-1.84,2.74-5.77,4.22-6.51a9.86,9.86,0,0,1-3.9-.43c1.36,1.36,1.73,2,.94,4.13s-1.74,2.25-2.85,4a24,24,0,0,0-2.47,6.62c-.32,1.59.08,7.73-.32,8.84s-.88,2.31-.88,2.31l1.09-.68C1079.71,71,1080.07,69.4,1080,66.14Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1073.81,68.61c0-1.44-2-2.55-2.63-4.94s-2-3-3.19-4.63-.79-1.83-.87-2.94a4.3,4.3,0,0,1-1.84,1h0a25.7,25.7,0,0,0,2.55,2.87c2.63,2.47,6.78,11.72,6.78,11.72C1074.69,71.08,1073.81,70,1073.81,68.61Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1074.61,62.23a27.23,27.23,0,0,0-.56-5.66c-.24-1.19-1-6.53-1.68-6.69a6.38,6.38,0,0,0-.64-.12,9.79,9.79,0,0,1,.64,2.83h0s.58,2.42.9,4.17a5.23,5.23,0,0,1,.22,1.57c0,.11,0,.24,0,.38,0,1.22.42.8.13,2.38C1073.93,62.05,1074.45,63.43,1074.61,62.23Z"
            fill="#318099"
          />
          <path
            d="M1085.37,41.91c-1.94-.52-3.68-.23-4,.7-.17.55.21,1.2.92,1.78C1081.75,42.54,1084.07,42,1085.37,41.91Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1068.83,40.07c-1.82,1.21-2.82,2.89-2.25,3.75a1.31,1.31,0,0,0,1.06.49c-1.55-1.73,3.7-5.11,4.07-5.34A6.31,6.31,0,0,0,1068.83,40.07Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.73,52.22l-.44.14c-1.46,1.15-2.2,2.57-1.69,3.33a1.48,1.48,0,0,0,1.34.49c0-.13.3-.24,1.26-.26l.12,0C1061.87,55.08,1064.73,52.22,1064.73,52.22Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1081.61,46.63s1.09,1.89-1.24,5.59-3.24,5.53-3.24,5.53"
          fill="#318099"
        />
        <path d="M1082.86,40.75s-4.44.74-1.48,3.7" fill="#318099" />
        <path d="M1067.05,41.12s-3.58,2.72.42,4" fill="#318099" />
        <path d="M1062.88,52.59s-3.11,3.09.89,4.33" fill="#318099" />
      </g>
      {/* <g>
        <path
          d="M354.9,200.39s10,20.21,53.64,17,20.93-13.76,12.45-17.09S354.9,200.39,354.9,200.39Z"
          fill="#0e3b68"
          opacity="0.32"
        />
        <g>
          <path
            d="M438.2,202.84a6,6,0,0,0,1.86-11.33c-5.17-2.58-12-3.68-17.92-1.13,17.65-7.57,26.68-16.81,15.13-25.22-9.25-6.72-23.54,17.65-26.9,17.65s1.68-10.08,9.25-19.33,6.72-16.81.84-19.33-16,1.68-18.49,27.74c0-4.21,1.68-30.26-5.05-27.74s-11.76,16.81-.84,31.94c-6.72,2.52-5.88-4.2-5.88-4.2s-3.36-25.22-15.13-20.17-8.4,18.49,0,26.89,8.41,13.45-2.52,8.41-16-16.81-26.05-5.05,17.65,26.06,33.62,26.9C391.69,209.48,422.26,205.23,438.2,202.84Z"
            fill="url(#f4e1f2e4-48ba-4ebd-9318-8021ccda52fe)"
          />
          <path
            d="M428,200.57c.6-4.78-8.36-9.55-15.52-3.58,10.75-9.55,13.13-17.32,7.76-17.32s-17.31,10.15-19.7,10.15,5.27-4.64,10.64-11.21,2.5-11.66-1.68-13.45c-3.92-1.68-15.8,2.1-18.85,17.72a2.74,2.74,0,0,1-1.87,2.06c-.92.3-2-2.13-2-2.13s-5.38-20.45-13.73-16.87-6,13.14,0,19.11,6,9.55-1.8,6-11.34-11.94-18.5-3.58,8.36,12.53,19.7,13.13S428,200.57,428,200.57Z"
            fill="url(#ba81f6ac-8d0a-47b0-8736-b31a68dd94ce)"
          />
          <path
            d="M407.18,207.27c-2.25-.81,6.53-2.59,13.81-7s6.3-10.12,3-13.22c-3.12-2.91-15.58-3.39-23.74,10.28a2.72,2.72,0,0,1-2.45,1.31c-1,0-1.14-2.67-1.14-2.67s1.87-21.06-7.21-20.52-10.06,10.33-6.47,18,2.39,11-3.7,5-6.63-15.08-16.2-9.64,3.61,14.63,14.08,19S409.42,208.08,407.18,207.27Z"
            fill="url(#b28aef1c-1307-436a-b58e-fabcd6ac6ba0)"
          />
        </g>
      </g> */}
      <g>
        <path
          d="M1271.44,452.91c6.6-1,8.09-9.92,2.13-12.9s-13.64-4.2-20.41-1.29c20.09-8.62,30.38-19.14,17.22-28.71-10.53-7.66-26.79,20.09-30.62,20.09s1.91-11.48,10.52-22,7.66-19.14,1-22-18.18,1.92-21,31.58c0-4.78,1.91-34.45-5.74-31.58s-13.4,19.14-1,36.37c-7.66,2.87-6.7-4.79-6.7-4.79s-3.83-28.71-17.22-23-9.57,21.05,0,30.62,9.56,15.31-2.88,9.57-18.18-19.14-29.66-5.74,20.09,29.66,38.28,30.62C1218.49,460.46,1253.29,455.62,1271.44,452.91Z"
          fill="url(#a401e909-d6ab-4ad8-9b0c-79703ec15590)"
        />
        <path
          d="M1259.87,450.32c.68-5.44-9.52-10.87-17.68-4.08,12.24-10.87,15-19.71,8.84-19.71s-19.71,11.56-22.43,11.56,6-5.29,12.11-12.77,2.85-13.27-1.91-15.31c-4.46-1.92-18,2.38-21.47,20.17a3.11,3.11,0,0,1-2.12,2.35c-1,.34-2.25-2.43-2.25-2.43s-6.12-23.28-15.63-19.21-6.8,15,0,21.76,6.79,10.87-2,6.8-12.92-13.6-21.08-4.08,9.52,14.27,22.44,14.95S1259.87,450.32,1259.87,450.32Z"
          fill="url(#b93956a2-ff8d-422b-8d5d-24d9f810271d)"
        />
        <path
          d="M1236.12,458c-2.56-.92,7.44-2.95,15.73-7.91s7.17-11.53,3.38-15.06c-3.55-3.31-17.74-3.85-27,11.71a3.09,3.09,0,0,1-2.79,1.49c-1.11,0-1.3-3-1.3-3s2.13-24-8.2-23.37-11.47,11.77-7.37,20.47,2.71,12.53-4.22,5.7-7.55-17.16-18.45-11,4.12,16.65,16,21.67S1238.68,458.87,1236.12,458Z"
          fill="url(#aa4f1180-7024-41ac-bccb-be5a22615aa9)"
        />
      </g>
      <g>
        <path
          d="M1402.57,505.21a5.11,5.11,0,0,0,1.58-9.6c-4.38-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.83-5.69-19.93,14.95-22.77,14.95s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37S1374,456.93,1371.89,479c0-3.55,1.42-25.62-4.27-23.48s-10,14.23-.71,27c-5.7,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C1363.19,510.83,1389.07,507.23,1402.57,505.21Z"
          fill="url(#b5ec5bc8-f633-4332-9fc6-809c1550697a)"
        />
        <path
          d="M1394,503.28c.51-4-7.07-8.08-13.14-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.06,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.68,11.12S1394,503.28,1394,503.28Z"
          fill="url(#e10e8b1e-a539-4c3f-8895-3dc0fa10d053)"
        />
        <path
          d="M1376.3,509c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.2-2.87-20.11,8.7a2.29,2.29,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.53,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.06,12.39,11.93,16.12S1378.2,509.64,1376.3,509Z"
          fill="url(#a23f39ca-9c99-4190-a50f-b5a908c0d082)"
        />
      </g>
      <g>
        <path
          d="M1130.19,551.28a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.11-13.52-14.23-22.06-4.27,14.94,22.07,28.47,22.78C1090.8,556.9,1116.69,553.3,1130.19,551.28Z"
          fill="url(#b1b4dd55-b30f-4e97-a430-6436ebecae6b)"
        />
        <path
          d="M1121.58,549.35c.5-4-7.08-8.09-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8S1082.14,517,1075.06,520s-5.06,11.12,0,16.18,5.06,8.09-1.52,5-9.6-10.11-15.67-3,7.08,10.62,16.69,11.12S1121.58,549.35,1121.58,549.35Z"
          fill="url(#f05a2ccf-d568-4995-8f4c-8af8be162f85)"
        />
        <path
          d="M1103.91,555c-1.9-.68,5.53-2.19,11.7-5.88s5.33-8.57,2.52-11.19c-2.64-2.47-13.2-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.06,12.39,11.93,16.12S1105.82,555.71,1103.91,555Z"
          fill="url(#ece085cd-cf6c-4418-8d58-1e4519b3756c)"
        />
      </g>
      <g>
        <path
          d="M965.07,267.3s14.87,20.49,49.65,14.41,42.57,4.59,46.47-2-13.71-21.81-31.45-23.9-64.67,11.53-64.67,11.53"
          fill="#0e3b68"
          opacity="0.32"
        />
        <g>
          <path
            d="M1053.49,268c6.39-1,7.83-9.61,2-12.49s-13.2-4.07-19.76-1.26c19.46-8.34,29.42-18.53,16.68-27.8-10.2-7.41-26,19.46-29.65,19.46s1.85-11.12,10.19-21.31,7.41-18.53.92-21.31-17.6,1.85-20.38,30.58c0-4.64,1.85-33.36-5.56-30.58s-13,18.53-.93,35.21c-7.41,2.78-6.48-4.63-6.48-4.63s-3.71-27.8-16.68-22.24-9.27,20.38,0,29.65,9.26,14.83-2.78,9.27S963.5,232,952.38,245s19.46,28.72,37.07,29.65C1002.21,275.34,1035.91,270.66,1053.49,268Z"
            fill="url(#b5e980cd-e6c1-49b0-bdd2-e27f875a7a92)"
          />
          <path
            d="M1042.28,265.52c.66-5.26-9.22-10.53-17.12-3.95,11.85-10.53,14.48-19.09,8.56-19.09s-19.09,11.19-21.72,11.19,5.81-5.12,11.73-12.36,2.76-12.85-1.85-14.83c-4.32-1.85-17.43,2.31-20.79,19.54a3,3,0,0,1-2.05,2.27c-1,.33-2.18-2.35-2.18-2.35s-5.93-22.55-15.14-18.6-6.59,14.49,0,21.07,6.58,10.53-2,6.58-12.5-13.16-20.4-4,9.21,13.82,21.72,14.48S1042.28,265.52,1042.28,265.52Z"
            fill="url(#ef62b08f-aa25-4986-b685-621f0f549d94)"
          />
          <path
            d="M1019.28,272.91c-2.48-.9,7.2-2.86,15.23-7.66s6.94-11.16,3.28-14.58c-3.44-3.21-17.18-3.73-26.18,11.34a3,3,0,0,1-2.7,1.44c-1.07,0-1.25-2.94-1.25-2.94s2.06-23.23-7.95-22.63-11.1,11.39-7.13,19.82,2.62,12.13-4.09,5.52-7.31-16.62-17.86-10.63,4,16.13,15.53,21S1021.76,273.8,1019.28,272.91Z"
            fill="url(#a77f6d32-80fb-43a7-a662-2b4c6b0bd7da)"
          />
        </g>
      </g>
      {/* <g>
        <ellipse
          cx="458.94"
          cy="363.81"
          rx="26.66"
          ry="5.58"
          fill="url(#a24e3659-b00d-428a-8602-3adf6e023498)"
        />
        <g>
          <path
            d="M498.64,360.22a5.56,5.56,0,0,0,1.71-10.44c-4.76-2.37-11-3.39-16.51-1,16.26-7,24.58-15.48,13.94-23.22-8.52-6.19-21.68,16.25-24.77,16.25s1.55-9.29,8.51-17.8,6.19-15.48.78-17.8-14.71,1.55-17,25.54c0-3.87,1.55-27.86-4.65-25.54s-10.83,15.48-.77,29.41c-6.19,2.32-5.42-3.87-5.42-3.87s-3.09-23.22-13.93-18.58-7.74,17,0,24.77,7.74,12.39-2.32,7.74-14.71-15.48-24-4.64,16.26,24,31,24.77C455.8,366.33,484,362.41,498.64,360.22Z"
            fill="url(#b76627b6-8419-4cbd-93f5-3b869b92ffaa)"
          />
          <path
            d="M489.27,358.13c.55-4.4-7.69-8.8-14.29-3.3,9.89-8.8,12.09-15.95,7.14-15.95s-15.94,9.35-18.14,9.35,4.85-4.28,9.8-10.33,2.3-10.73-1.55-12.38c-3.6-1.55-14.55,1.93-17.36,16.31a2.5,2.5,0,0,1-1.72,1.9c-.85.28-1.81-2-1.81-2s-4.95-18.83-12.65-15.53-5.5,12.09,0,17.59,5.5,8.8-1.65,5.5-10.45-11-17-3.3,7.69,11.55,18.14,12.1S489.27,358.13,489.27,358.13Z"
            fill="url(#baa786aa-35ab-4c7d-a7c2-9247da50aaca)"
          />
          <path
            d="M470.06,364.29c-2.06-.74,6-2.38,12.72-6.39s5.81-9.32,2.74-12.18c-2.87-2.68-14.34-3.12-21.86,9.47a2.5,2.5,0,0,1-2.26,1.2c-.89,0-1-2.46-1-2.46s1.73-19.39-6.63-18.9-9.27,9.52-6,16.56,2.19,10.14-3.42,4.61-6.1-13.88-14.92-8.87,3.34,13.47,13,17.52S472.13,365,470.06,364.29Z"
            fill="url(#ab13e1a4-f422-44b2-ac17-6b5c8618b015)"
          />
        </g>
      </g> */}
      {/* <g>
        <ellipse
          cx="502.02"
          cy="378.33"
          rx="18.39"
          ry="3.85"
          fill="url(#afadb3f4-1ddd-4bec-9b0d-ba841e6f5aed)"
        />
        <g>
          <path
            d="M529.4,375.85a3.83,3.83,0,0,0,1.18-7.2,13.83,13.83,0,0,0-11.39-.72c11.21-4.8,16.95-10.67,9.61-16-5.87-4.27-14.94,11.21-17.08,11.21s1.07-6.41,5.87-12.28,4.27-10.68.54-12.28-10.14,1.07-11.75,17.62c0-2.67,1.07-19.22-3.2-17.62s-7.47,10.68-.53,20.29c-4.27,1.6-3.74-2.67-3.74-2.67s-2.13-16-9.61-12.81-5.33,11.74,0,17.08,5.34,8.54-1.6,5.34-10.14-10.68-16.55-3.21,11.21,16.55,21.36,17.08C499.86,380.06,519.27,377.36,529.4,375.85Z"
            fill="url(#a5c683ed-fcd6-42ab-8de9-db790a9a652b)"
          />
          <path
            d="M522.94,374.41c.38-3-5.31-6.07-9.86-2.28,6.83-6.07,8.34-11,4.93-11s-11,6.45-12.51,6.45,3.34-2.95,6.76-7.12,1.58-7.4-1.07-8.54c-2.49-1.07-10,1.33-12,11.25a1.73,1.73,0,0,1-1.18,1.31c-.59.19-1.25-1.35-1.25-1.35s-3.42-13-8.73-10.72-3.79,8.34,0,12.14,3.8,6.06-1.13,3.79-7.21-7.59-11.76-2.28,5.31,8,12.51,8.35S522.94,374.41,522.94,374.41Z"
            fill="url(#a1f869f9-f354-4434-a31a-5492ac5aa141)"
          />
          <path
            d="M509.69,378.66c-1.42-.52,4.15-1.64,8.77-4.41s4-6.43,1.89-8.4-9.89-2.15-15.08,6.53a1.71,1.71,0,0,1-1.55.83c-.62,0-.72-1.7-.72-1.7s1.18-13.37-4.58-13S492,365,494.31,369.9s1.51,7-2.36,3.18-4.21-9.58-10.29-6.12,2.3,9.29,8.95,12.08S511.12,379.17,509.69,378.66Z"
            fill="url(#fe1a40bb-17a2-409c-b597-09bba327db3b)"
          />
        </g>
      </g> */}
      {/* <g>
        <ellipse
          cx="422.52"
          cy="388.52"
          rx="18.39"
          ry="3.85"
          fill="url(#b153d63d-3a36-4126-92bc-70472286eb25)"
        />
        <g>
          <path
            d="M449.9,386.05a3.83,3.83,0,0,0,1.19-7.2,13.83,13.83,0,0,0-11.39-.72c11.21-4.8,16.95-10.68,9.61-16-5.87-4.27-14.95,11.21-17.08,11.21s1.07-6.41,5.87-12.28,4.27-10.68.53-12.28-10.14,1.07-11.74,17.62c0-2.67,1.07-19.22-3.2-17.62s-7.48,10.68-.54,20.29c-4.27,1.6-3.73-2.67-3.73-2.67s-2.14-16-9.61-12.81-5.34,11.74,0,17.08,5.34,8.54-1.6,5.33-10.14-10.67-16.55-3.2,11.21,16.55,21.35,17.08C420.36,390.26,439.78,387.56,449.9,386.05Z"
            fill="url(#a1e77f8e-89c2-41ca-9196-8f78fd343bc5)"
          />
          <path
            d="M443.44,384.6c.38-3-5.3-6.06-9.85-2.27,6.82-6.07,8.34-11,4.93-11s-11,6.45-12.52,6.45,3.35-2.95,6.76-7.12,1.59-7.41-1.07-8.54c-2.48-1.07-10,1.32-12,11.25a1.74,1.74,0,0,1-1.18,1.31c-.59.19-1.26-1.35-1.26-1.35s-3.41-13-8.72-10.72-3.79,8.34,0,12.13,3.79,6.07-1.14,3.8-7.2-7.59-11.75-2.28,5.31,8,12.51,8.34S443.44,384.6,443.44,384.6Z"
            fill="url(#b1387e3a-3a6e-49cb-afa6-6b665b6b6ef5)"
          />
          <path
            d="M430.2,388.86c-1.43-.52,4.15-1.65,8.77-4.41s4-6.43,1.89-8.4-9.9-2.15-15.08,6.53a1.75,1.75,0,0,1-1.56.83c-.61,0-.72-1.7-.72-1.7s1.19-13.37-4.58-13-6.39,6.56-4.11,11.41,1.52,7-2.35,3.19-4.21-9.58-10.29-6.13,2.3,9.3,8.95,12.09S431.63,389.37,430.2,388.86Z"
            fill="url(#a863ecb7-fc97-4fff-9a65-e6e72d371a32)"
          />
        </g>
      </g> */}
      {/* <g>
        <path
          d="M1382.3,533.18c-.71-21.2,12.72-33.21,11.3-34.63s-2.82-6.36-12.72,0-14.13,61.49-2.82,101.77a129.26,129.26,0,0,1,4.86,36.34q5,.06,10,.07c.19-2.09.41-3.9.66-5.31C1395.72,619.4,1383,554.38,1382.3,533.18Z"
          fill="url(#a2ba31e7-73c4-46b4-b28c-bb73833c81a2)"
        />
        <path
          d="M1371,519.05c-.71-21.2,12.72-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.48-2.83,101.77a133,133,0,0,1,4.11,50.28c3.27.07,6.55.12,9.83.17.42-8.06.89-15.31,1.61-19.36C1384.42,605.27,1371.7,540.25,1371,519.05Z"
          fill="url(#aca654cc-46a3-4f32-8ae6-ed59aca9a11e)"
        />
        <path
          d="M1393.6,509.86c-.7-21.2,12.73-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.13,61.49-2.83,101.77c6.73,24,5.2,43.43,3,59.73h10.47c.56-11.44,1.09-23.07,2.07-28.64C1407,596.08,1394.31,531.06,1393.6,509.86Z"
          fill="url(#a9114228-b6bd-4e8d-a812-07d75b509091)"
        />
        <path
          d="M1359.68,502.09c-.71-21.21,12.72-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.48-2.83,101.76c7.73,27.56,4.56,49.15,2,66.84,3.69.14,7.39.26,11.08.35.74-13.49,1.26-29.3,2.46-36.09C1373.11,588.31,1360.39,523.29,1359.68,502.09Z"
          fill="url(#b5123c89-b04f-42f0-adc7-8888705e3d12)"
        />
        <path
          d="M1348.37,526.82c-.7-21.2,12.72-33.21,11.31-34.63s-2.83-6.36-12.72,0-14.13,61.49-2.83,101.77a129.42,129.42,0,0,1,4.72,41.71c3.24.17,6.47.31,9.71.43.31-4.57.67-8.46,1.12-11C1361.8,613,1349.08,548,1348.37,526.82Z"
          fill="url(#a922b89b-50a9-4047-ae2b-eff3eaa1d93d)"
        />
        <path
          d="M1325.76,526.82c-.71-21.2,12.72-33.21,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.49-2.83,101.77a129.44,129.44,0,0,1,4.79,40.1c3.24.3,6.48.58,9.72.82.29-4,.62-7.48,1-9.82C1339.19,613,1326.47,548,1325.76,526.82Z"
          fill="url(#a52f9987-95e7-47af-9f92-b2a69f1eae39)"
        />
        <path
          d="M1337.07,509.86c-.71-21.2,12.72-33.22,11.3-34.63s-2.82-6.36-12.72,0-14.13,61.49-2.82,101.77c6.47,23.07,5.3,42,3.24,57.88q5.15.38,10.29.66c.54-11,1.07-22.07,2-27.45C1350.49,596.08,1337.77,531.06,1337.07,509.86Z"
          fill="url(#b6ea1e3e-c4b9-4ff0-8153-ea46502058be)"
        />
        <path
          d="M1416.22,486.54c-.71-21.2,12.72-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.48-2.83,101.77c10.27,36.57,1.31,62.66.1,83l11.78-.07c1.62-13.2,1.93-42,3.67-51.86C1429.65,572.76,1416.93,507.74,1416.22,486.54Z"
          fill="url(#f060c945-90d2-41fb-a084-d4b1c1eb83b2)"
        />
        <path
          d="M1389.36,632.83s7.78,5.65,10.6,0,2.83-45.94,5-58-10.6-77-11.31-98.24,12.73-33.21,11.31-34.63-2.83-6.36-12.72,0-14.13,61.49-2.83,101.77S1388.66,611.63,1389.36,632.83Z"
          fill="url(#f4b5992e-b37c-4771-8603-e6aeddbb507c)"
        />
        <path
          d="M1355.44,632.83s7.77,5.65,10.6,0,2.83-45.94,5-58-10.6-77-11.31-98.24S1372.4,443.43,1371,442s-2.83-6.36-12.72,0-14.14,61.49-2.83,101.77S1354.73,611.63,1355.44,632.83Z"
          fill="url(#ec06554a-4ede-4b7f-a874-90404325f9d4)"
        />
        <path
          d="M1325.76,505.62c-1.41-1.41-2.83-6.36-12.72,0s-14.14,61.48-2.83,101.77a129.1,129.1,0,0,1,4.51,25.46q5.63.66,11.27,1.19c-.3-18.89-10.9-74.49-11.54-93.79C1313.74,519.05,1327.17,507,1325.76,505.62Z"
          fill="url(#b23271fa-d184-4c01-8daa-d4be272b216e)"
        />
        <path
          d="M1404.91,533.18c-.71-21.2,12.72-33.21,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.49-2.83,101.77a128.63,128.63,0,0,1,4.86,36.41l10-.05c.19-2.07.41-3.86.66-5.26C1418.34,619.4,1405.62,554.38,1404.91,533.18Z"
          fill="url(#bf49c937-a0da-4684-9b9b-32be3e28edfe)"
        />
      </g> */}
      {/* <g>
        <path
          d="M1270.49,556.74c-.54-16.23,9.74-25.42,8.66-26.51s-2.17-4.86-9.74,0-10.82,47.07-2.17,77.91A98.08,98.08,0,0,1,1271,636l7.67.06c.16-1.61.32-3,.52-4.07C1280.77,622.74,1271,573,1270.49,556.74Z"
          fill="url(#b7a778e5-abb3-46cb-bb39-e741b9cde7a6)"
        />
        <path
          d="M1261.83,545.92c-.54-16.23,9.74-25.42,8.66-26.5s-2.16-4.87-9.74,0-10.82,47.06-2.16,77.9a101.67,101.67,0,0,1,3.14,38.48q3.76.09,7.53.13c.32-6.16.68-11.71,1.23-14.81C1272.11,611.92,1262.38,562.15,1261.83,545.92Z"
          fill="url(#bbd00fc3-7654-4042-970c-a933a5240a53)"
        />
        <path
          d="M1279.15,538.89c-.55-16.23,9.73-25.43,8.65-26.51s-2.16-4.87-9.74,0-10.82,47.07-2.16,77.9c5.15,18.35,4,33.25,2.3,45.72h8c.44-8.76.84-17.66,1.59-21.92C1289.42,604.89,1279.69,555.12,1279.15,538.89Z"
          fill="url(#bbdb894c-6a9f-43c2-80ce-727a7a9b2180)"
        />
        <path
          d="M1253.18,532.94c-.54-16.23,9.74-25.43,8.65-26.51s-2.16-4.87-9.73,0-10.82,47.07-2.17,77.9c5.92,21.09,3.49,37.62,1.54,51.16q4.24.16,8.48.27c.57-10.33,1-22.43,1.88-27.62C1263.46,598.94,1253.72,549.17,1253.18,532.94Z"
          fill="url(#b24f983a-ff8a-4aee-b324-561a9f936498)"
        />
        <path
          d="M1244.52,551.87c-.54-16.23,9.74-25.42,8.66-26.5s-2.17-4.87-9.74,0-10.82,47.06-2.16,77.9a99.45,99.45,0,0,1,3.61,31.93c2.48.12,4.95.23,7.43.33.24-3.5.51-6.48.86-8.46C1254.8,617.87,1245.06,568.1,1244.52,551.87Z"
          fill="url(#e467504d-43e2-4e41-9edb-9885c61bfe61)"
        />
        <path
          d="M1227.21,551.87c-.54-16.23,9.74-25.42,8.66-26.5s-2.17-4.87-9.74,0-10.82,47.06-2.16,77.9a98.93,98.93,0,0,1,3.66,30.7c2.48.22,5,.44,7.44.62.23-3.1.48-5.72.8-7.52C1237.49,617.87,1227.75,568.1,1227.21,551.87Z"
          fill="url(#b22bcdc7-0809-4ee8-9fca-7fab90ac5d1a)"
        />
        <path
          d="M1235.87,538.89c-.54-16.23,9.74-25.43,8.65-26.51s-2.16-4.87-9.73,0-10.82,47.07-2.17,77.9c5,17.66,4.06,32.12,2.49,44.31,2.62.19,5.25.36,7.87.5.42-8.46.82-16.89,1.54-21C1246.15,604.89,1236.41,555.12,1235.87,538.89Z"
          fill="url(#ac4e9645-94d4-424f-b989-cd1484b3d4ec)"
        />
        <path
          d="M1296.46,521c-.54-16.23,9.73-25.43,8.65-26.51s-2.16-4.87-9.74,0-10.81,47.07-2.16,77.9c7.86,28,1,48,.08,63.55l9-.05c1.23-10.11,1.47-32.16,2.8-39.7C1306.74,587,1297,537.27,1296.46,521Z"
          fill="url(#b98edb72-e641-4420-bc8e-80d0fa6ad9d5)"
        />
        <path
          d="M1275.9,633s5.95,4.33,8.11,0,2.17-35.16,3.79-44.36-8.11-59-8.65-75.2,9.73-25.42,8.65-26.5-2.16-4.87-9.74,0-10.82,47.06-2.16,77.9S1275.36,616.79,1275.9,633Z"
          fill="url(#af43ce8c-20b4-4a50-b7bb-2e569fee1e3f)"
        />
        <path
          d="M1249.93,633s6,4.33,8.12,0,2.16-35.16,3.78-44.36-8.11-59-8.65-75.2,9.74-25.42,8.65-26.5-2.16-4.87-9.73,0-10.82,47.06-2.17,77.9S1249.39,616.79,1249.93,633Z"
          fill="url(#a409fa29-b4e6-47bf-aaa9-fd585a8eeb98)"
        />
        <path
          d="M1227.21,535.64c-1.08-1.08-2.16-4.86-9.74,0s-10.82,47.07-2.16,77.9a98.88,98.88,0,0,1,3.45,19.49c2.87.34,5.75.65,8.63.91-.23-14.45-8.34-57-8.83-71.79C1218,545.92,1228.29,536.73,1227.21,535.64Z"
          fill="url(#b6f981e5-f550-48c4-997d-6c98d3e5e07d)"
        />
        <path
          d="M1287.8,556.74c-.54-16.23,9.74-25.42,8.66-26.51s-2.17-4.86-9.74,0-10.82,47.07-2.16,77.91a99.13,99.13,0,0,1,3.72,27.86l7.67,0c.15-1.59.32-3,.51-4C1298.08,622.74,1288.34,573,1287.8,556.74Z"
          fill="url(#f49b43dd-7616-47f6-aa38-ec4c97e1f938)"
        />
      </g> */}
    </g>
  );
};

export default Decor2;
